<agr-form-dialog [formGroup]="formGroup" [contentSpacing]="false" [data]="data" (confirm)="process($event)" (cancel)="cancel($event)" (alt)="alt($event)">
  <div data-test="customer-product-inventory-table">
    @if ((filteredCropAids$ | async)?.length === 0 && !hasFilter) {
      <p class="wrapper--spacing-horizontal">
        {{ 'noProductsInInventory' | translate }}
      </p>
    }
    @if ((filteredCropAids$ | async)?.length > 0 || hasFilter) {
      <mat-table [dataSource]="filteredCropAids$" style="min-width: 720px">
        <ng-container matColumnDef="product" sticky>
          <mat-header-cell *matHeaderCellDef class="mat-input-cell flex__child flex__child-gt-sm-2">
            <mat-form-field>
              <input matInput [placeholder]="'search' | translate" data-test="product-inventory-dialog-filter" [formControl]="cropAidFilter" />
            </mat-form-field>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex__child flex__child-gt-sm-2">
            <mat-icon [color]="getShortageAmount(element.index) ? 'warn' : 'primary'" class="spacing--margin-right">
              {{ getShortageAmount(element.index) ? 'warning' : 'check' }}
            </mat-icon>
            {{ element.cropAid?.name }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="requisite">
          <mat-header-cell *matHeaderCellDef>{{ 'requisite' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.requisiteAmount | agrNumber: '1.0-2' }}
            {{ element.cropAid.unitOfMeasurement }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="ordered">
          <mat-header-cell *matHeaderCellDef>{{ 'order' | switchTranslation }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.orderLinesTotalAmount | agrNumber }}
            {{ element.cropAid.unitOfMeasurement }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="inventory">
          <mat-header-cell *matHeaderCellDef>{{ 'productInventory' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element" class="mat-input-cell">
            <mat-form-field appearance="fill" class="dialog-product-inventory-input full-width-field spacing--padding-right" style="box-sizing: border-box">
              <mat-label>{{ ('productInventory' | translate) + ' in ' + element.cropAid.unitOfMeasurement }}</mat-label>
              <input
                matInput
                [step]="0.01"
                min="0"
                maxlength="7"
                agrNumber
                [formControl]="getProductInventoryControl(element.index)"
                [attr.data-test]="'product-inventory-dialog-input-' + element.index"
              />
            </mat-form-field>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="result">
          <mat-header-cell *matHeaderCellDef>{{ 'result' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            @if (getShortageAmount(element.index); as shortageAmount) {
              <span class="text--error">
                <span class="text--bold">-</span>
                {{ shortageAmount | agrNumber: '1.0-2' }} {{ element.cropAid.unitOfMeasurement }}
              </span>
            }
            @if (getExcessAmount(element.index); as excessAmount) {
              <span class="text--warning">
                <span class="text--bold">+</span> {{ excessAmount | agrNumber: '1.0-2' }}
                {{ element.cropAid.unitOfMeasurement }}
              </span>
            }
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    }
  </div>
</agr-form-dialog>
